/** 阿里云灵眸：数字人并发超过配额 */
export const LINGMOU_CONCURRENCY_CODE = "HA15110000000701";

export const AVATAR_BUSY_MESSAGE =
    "当前问询人数较多，数字人通道已满。请稍等片刻后再试。";

export function isAvatarBusyError(
    raw?: string | null,
    code?: string | null,
): boolean {
    if (code === LINGMOU_CONCURRENCY_CODE) return true;
    if (!raw) return false;
    return /HA15110000000701|并发量超过限额|并发已满|通道已满/.test(raw);
}

export function formatAvatarSessionError(
    raw?: string | null,
    code?: string | null,
): string {
    if (isAvatarBusyError(raw, code)) return AVATAR_BUSY_MESSAGE;
    return (raw && raw.trim()) || "数字人启动失败，请稍后重试";
}
